import { render, staticRenderFns } from "./MainBtn.vue?vue&type=template&id=ef289026&scoped=true"
import script from "./MainBtn.vue?vue&type=script&lang=js"
export * from "./MainBtn.vue?vue&type=script&lang=js"
import style0 from "./MainBtn.vue?vue&type=style&index=0&id=ef289026&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef289026",
  null
  
)

export default component.exports